import { render, staticRenderFns } from "./notDashboard.vue?vue&type=template&id=02ae40f8&"
import script from "./notDashboard.vue?vue&type=script&lang=js&"
export * from "./notDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports